import { GameState } from 'macguffin'
import initialState from './initialState'

const createReducer = GameState.createReducer

import {
    SET_REFRESH,
    SET_REELS_CONFIG,
    SET_CURRENT_SPIN_DATA,
    RESUME_GAME,
    RESUME_SPIN,
    START_SPIN,
    REEL_STOPPED,
    SPIN_COMPLETE,
    START_RESPIN,
    RESPIN_COMPLETE,
    SET_RESPIN_SUMMARY,

    SET_CURRENT_COMET_WILDS_DATA,
    COMET_WILDS_MOVEMENT_COMPLETE,

    SET_CURRENT_WIN_DATA,
    SET_CURRENT_WIN_RESULT,
    SET_CURRENT_WIN_COUNTUP,
    SET_CURRENT_WIN_ITERATION,

    START_COUNTDOWN,
    START_BONUS,
    SET_CURRENT_PICKS_DATA,
    START_PICK_STAGE,
    PICK_ITEM,
    SET_CURRENT_PICK_RESULT_DATA,
    ADD_EMERGENCY_FUEL,
    PICK_STAGE_COMPLETE,
    START_FREESPIN,
    SET_FREESPIN_OUTCOME,
    FREESPIN_COMPLETE,
    SET_FREESPIN_SUMMARY,
    FREESPIN_SUMMARY_COMPLETE,

    SET_JACKPOT,
    START_MARS_SEQUENCE,
    SET_JACKPOT_DRAW,
    BONUS_COMPLETE,
    REVERT_GAME
} from './constants'

import GameMode from "game/modes"
import GameModeGroup from "game/modes/GameModeGroup"
import ArrayHelper from "utils/ArrayHelper"

const scatterCountGroup = new GameModeGroup([GameMode.MAIN, GameMode.COMET_WILDS, GameMode.RESPIN])

export default function gameReducer(state = initialState, action) {
  switch (action.type) {
    case REVERT_GAME: {
        return createReducer(state, { currentGameMode: GameMode.REVERT, isSpinning: false })
    }

    case SET_REFRESH: {
        const { refresh } = action
        return createReducer(state, { refresh })
    }
    case SET_REELS_CONFIG: {
        const { reelsConfig } = action
        return createReducer(state, { reelsConfig })
    }
    case SET_CURRENT_SPIN_DATA: {
        const { currentSpinData } = action

        const newState = {
            currentSpinData
        }

        return createReducer(state, newState)
    }
    case RESUME_GAME: {
        return createReducer(state, { currentGameMode: GameMode.RESUME })
    }
    case RESUME_SPIN: {
        const {
            currentRespinIndex,
            currentFreespinIndex,
            currentPickStageIndex,
            meterPosition,
            currentFreespins
        } = action

        const newState = {
            currentRespinIndex,
            currentFreespinIndex,
            currentPickStageIndex,
            meterPosition,
            currentFreespins
        }

        return createReducer(state, newState)
    }
    case START_SPIN: {
        const newState = {
            currentGameMode: GameMode.MAIN,
            isSpinning: true,
            reelStoppedIndex: -1,
            currentWinData: undefined,
            currentWinCountUp: undefined,
            currentWinIteration: undefined,
            currentRespinIndex: -1,
            currentCometWildsData: undefined,
            currentFreespinIndex: undefined,
            currentFreespins: 0,
            extraFreespins: 0,
            meterPosition: undefined,
            currentPickStageIndex: undefined,
            respinSummary: undefined,
            freespinSummary: undefined
        }

        return createReducer(state, newState)
    }
    case REEL_STOPPED: {
        const { reelStoppedIndex } = action
        const {
            reelStoppedIndex: currentStoppedIndex,
            currentGameMode,
            currentFreespins = 0,
            currentSpinData
        } = state

        const newState = {
            reelStoppedIndex
        }

        if (reelStoppedIndex > currentStoppedIndex) {
            //count the scatter symbols that stop on the main reels
            if (scatterCountGroup.contains(currentGameMode)) {
                const { symbols } = currentSpinData
                const reel = symbols[reelStoppedIndex]

                const scatterSymbols = reel.filter((symbol) => {
                    return symbol === "SC"
                })

                const newFreespins = currentFreespins + scatterSymbols.length

                if (newFreespins) {
                    const extraFreespins = newFreespins - 5

                    Object.assign(newState, {
                        currentFreespins: newFreespins,
                        extraFreespins
                    })
                }
            }
        }

        return createReducer(state, newState)
    }
    case SPIN_COMPLETE: {
        return createReducer(state, { isSpinning: false })
    }
    case SET_CURRENT_WIN_DATA: {
        const { currentWinData, winTotal } = action
        const { reelsConfig } = state
        const { paylines } = reelsConfig

        const winData = currentWinData.map((lineData) => {
            const lineIndex = lineData[1] - 1

            return {
                lineIndices: paylines[lineIndex],
                symbol: lineData[4],
                type: lineData[0],
                win: lineData[2],
                winningSymbols: lineData[3]
            }
        })

        const newState = {
            currentWinData: winData,
            winTotal
        }

        return createReducer(state, newState)
    }
    case SET_CURRENT_WIN_COUNTUP: {
        const { currentWinCountUp } = action

        const newState = {
            currentWinCountUp
        }

        return createReducer(state, newState)
    }
    case SET_CURRENT_WIN_ITERATION: {
        const { currentWinIteration } = action

        const newState = {
            // currentWinCountUp: undefined,
            currentWinIteration
        }

        return createReducer(state, newState)
    }
    case START_RESPIN: {
        const { currentRespinIndex } = action

        const newState = {
            currentGameMode: GameMode.RESPIN,
            currentRespinIndex,
            isSpinning: true,
            reelStoppedIndex: -1,
            currentWinData: undefined,
            currentWinCountUp: undefined,
            currentWinIteration: undefined
        }

        return createReducer(state, newState)
    }
    case RESPIN_COMPLETE: {
        return createReducer(state, { isSpinning: false })
    }
    case SET_RESPIN_SUMMARY: {
        const newState = {
            currentWinCountUp: undefined,
            respinSummary: true
        }
        return createReducer(state, newState)
    }
    case SET_CURRENT_COMET_WILDS_DATA: {
        const { currentCometWildsData } = action
        const newState = {
            currentWinData: undefined,
            currentWinCountUp: undefined,
            currentCometWildsData,
            currentGameMode: GameMode.COMET_WILDS
        }
        return createReducer(state, newState)
    }
    case COMET_WILDS_MOVEMENT_COMPLETE: {
        return createReducer(state, { currentGameMode: GameMode.RESPIN })
    }
    case START_COUNTDOWN: {
        return createReducer(state, { currentGameMode: GameMode.BONUS_COUNTDOWN })
    }
    case START_BONUS: {
        const newState = {
            currentGameMode: GameMode.BONUS_INTRO,
            currentCometWildsData: undefined,
            meterPosition: 0,
            collectedBoosts: undefined,
            currentWinData: undefined,
            currentWinCountUp: undefined,
            currentWinIteration: undefined,
            respinSummary: undefined,
            freespinSummary: undefined
        }
        return createReducer(state, newState)
    }
    case SET_CURRENT_PICKS_DATA: {
        const { currentPicksData, collectedBoosts } = action

        const newState =  {
            currentPicksData,
            currentPickResultData: undefined,
            collectedBoosts
        }

        if (collectedBoosts && collectedBoosts.length) {
            const latestBoost = ArrayHelper(collectedBoosts).last()
            const { featureExtras } = latestBoost || {}
            const { spinsLeft = 0 } = featureExtras

            if (spinsLeft) {
                newState.currentFreespins = spinsLeft
            }
        }

        return createReducer(state, newState)
    }
    case START_PICK_STAGE: {
        const { currentPickStageIndex } = action
        const newState = {
            extraFreespins: 0,
            currentPickStageIndex,
            currentGameMode: GameMode.PICK,
            meterPosition: (currentPickStageIndex * 5)
        }
        return createReducer(state, newState)
    }
    case PICK_ITEM: {
        const { pickIndex } = action
        return createReducer(state, { pickIndex })
    }
    case SET_CURRENT_PICK_RESULT_DATA: {
        const { currentPickResultData } = action
        const { currentFreespins } = state

        //get any extra freespins from the pick mode
        const latestPickData = ArrayHelper(currentPickResultData).last()
        const { featureExtras, picks } = latestPickData
        const { spinsLeft = 0, spinsPlayed } = featureExtras

        const pick = picks.find((pick) => {
            return (pick.type === "EXTRA_FUEL" && pick.picked)
        })

        const extraFreespins = pick ? pick.value : 0
        const newFreespins = spinsLeft + extraFreespins

        //start from the latest freespins
        const currentFreespinIndex = spinsPlayed - 1

        const newState = {
            currentPickResultData,
            currentFreespins: newFreespins,
            currentFreespinIndex,
            extraFreespins,
            collectedBoosts: undefined
        }

        return createReducer(state, newState)
    }
    case ADD_EMERGENCY_FUEL: {
        const { currentPickResultData, currentFreespins, extraFreespins } = state
        const latestPickData = ArrayHelper(currentPickResultData).last()
        const { featureExtras, picks, emergencyFuel = 0 } = latestPickData

        if (emergencyFuel) {
            return createReducer(state, {
                currentFreespins: 1,
                extraFreespins: 1
            })
        }

        return state
    }
    case PICK_STAGE_COMPLETE: {
        const newState = {
            currentPicksData: undefined,
            pickIndex: undefined
        }
        return createReducer(state, newState)
    }
    case START_FREESPIN: {
        const { currentFreespinIndex } = action
        const { currentFreespins, currentGameMode, currentSpinData } = state

        const newFreespins = currentFreespins - 1

        const newState = {
            currentGameMode: GameMode.FREESPIN,
            currentFreespinIndex,
            isSpinning: true,
            reelStoppedIndex: -1,
            currentWinData: undefined,
            currentWinCountUp: undefined,
            currentWinIteration: undefined,
            currentFreespins: newFreespins,
            extraFreespins: 0
        }

        return createReducer(state, newState)
    }
    case FREESPIN_COMPLETE: {
        const { currentSpinData } = state
        const { featureExtras, winnings, symbols } = currentSpinData
        const { meterPosition, spinsLeft } = featureExtras

        const newMeterPosition = meterPosition + (winnings.length ? 1 : 0)

        const extraFreespins = symbols.reduce((sum, reel) => {
            const scatterSymbols = reel.filter((symbol) => {
                return symbol === "SC"
            })

            return sum + scatterSymbols.length
        }, 0)

        const newFreespins = spinsLeft - 1 + extraFreespins

        const newState = {
            currentFreespins: newFreespins,
            extraFreespins,
            isSpinning: false,
            meterPosition: newMeterPosition
        }

        return createReducer(state, newState)
    }
    case SET_FREESPIN_SUMMARY: {
        const newState = {
            extraFreespins: 0,
            currentWinCountUp: undefined,
            freespinSummary: true
        }

        return createReducer(state, newState)
    }

    case FREESPIN_SUMMARY_COMPLETE: {
        return createReducer(state, { freespinSummaryComplete: true })
    }

    case SET_JACKPOT: {
        const { jackpot } = action
        return createReducer(state, { jackpot })
    }
    case START_MARS_SEQUENCE: {
        const newState = {
            currentGameMode: GameMode.MARS_INTRO
        }

        return createReducer(state, newState)
    }
    case SET_JACKPOT_DRAW: {
        const { jackpotDraw } = action

        const newState = {
            currentGameMode: GameMode.JACKPOT_DRAW,
            jackpotDraw
        }

        return createReducer(state, newState)
    }
    case BONUS_COMPLETE: {

        const newState = {
            reelStoppedIndex: -1,
            currentFreespinIndex: undefined,
            currentFreespins: 0,
            currentGameMode: GameMode.MAIN,
            currentPickStageIndex: undefined,
            extraFreespins: 0,
            jackpotDraw: undefined,
            meterPosition: undefined,
            collectedBoosts: undefined,
            freespinSummaryComplete: undefined,
            currentWinData: undefined,
            currentWinCountUp: undefined,
            currentWinIteration: undefined
        }

        return createReducer(state, newState)
    }
    default:
      return state;
  }
}
